import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/kakobuy-spreadsheet-poradnik/page";
import SafetyArticle from "../pages/article/kakobuy-bezpieczenstwo/page";
import ComparisonArticle from "../pages/article/kakobuy-porownania/page";
import ShippingArticle from "../pages/article/kakobuy-wysylka-polska/page";
import ShoesArticle from "../pages/article/najlepsze-buty-kakobuy/page";
import ClothingArticle from "../pages/article/kakobuy-odziez-przeglad/page";
import AccessoriesArticle from "../pages/article/kakobuy-akcesoria/page";
import VsCnfansArticle from "../pages/article/kakobuy-vs-cnfans/page";
import VsSuperbuyArticle from "../pages/article/kakobuy-vs-superbuy/page";
import BeginnerGuide from "../pages/article/kakobuy-poradnik-poczatkujacy/page";
import HiddenFindsArticle from "../pages/article/ukryte-kakobuy-finds/page";
import PaymentSafetyArticle from "../pages/article/bezpieczne-platnosci-kakobuy/page";
import ShippingCostArticle from "../pages/article/koszty-wysylki-kakobuy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-poradnik/",
    element: <ArticlePage />,
  },
  {
    path: "/artykul/kakobuy-bezpieczenstwo/",
    element: <SafetyArticle />,
  },
  {
    path: "/artykul/kakobuy-porownania/",
    element: <ComparisonArticle />,
  },
  {
    path: "/artykul/kakobuy-wysylka-polska/",
    element: <ShippingArticle />,
  },
  {
    path: "/artykul/najlepsze-buty-kakobuy/",
    element: <ShoesArticle />,
  },
  {
    path: "/artykul/kakobuy-odziez-przeglad/",
    element: <ClothingArticle />,
  },
  {
    path: "/artykul/kakobuy-akcesoria/",
    element: <AccessoriesArticle />,
  },
  {
    path: "/artykul/kakobuy-vs-cnfans/",
    element: <VsCnfansArticle />,
  },
  {
    path: "/artykul/kakobuy-vs-superbuy/",
    element: <VsSuperbuyArticle />,
  },
  {
    path: "/artykul/kakobuy-poradnik-poczatkujacy/",
    element: <BeginnerGuide />,
  },
  {
    path: "/artykul/ukryte-kakobuy-finds/",
    element: <HiddenFindsArticle />,
  },
  {
    path: "/artykul/bezpieczne-platnosci-kakobuy/",
    element: <PaymentSafetyArticle />,
  },
  {
    path: "/artykul/koszty-wysylki-kakobuy/",
    element: <ShippingCostArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;